import { useGetMainSearchQuery } from '@/app/(main)/search/hooks/useGetMainSearchQuery';
import { goToSearchDetails } from '@/app/(main)/search/utils/goToSearchDetailsPath';
import { SEARCH_CATEGORIES } from '@/consts/search-const';
import type { GlobalSearchCategory, GlobalSearchFaqItem } from '@/types/globalSearchApiTypes';
import { CategoryWrapper } from '../CategoryWrapper';
import { FaqItem } from '../FaqItem';

interface FaqCategoryProps {
  data: GlobalSearchCategory<GlobalSearchFaqItem>;
}

export const FaqCategory = ({ data }: FaqCategoryProps) => {
  const { search } = useGetMainSearchQuery();
  return (
    <CategoryWrapper
      categoryName="FAQs"
      itemsCount={data.count}
      redirectToDetails={goToSearchDetails({ category: SEARCH_CATEGORIES.FAQ, searchQuery: search })}
    >
      {data.results.map((item) => (
        <FaqItem key={item.question} item={item} />
      ))}
    </CategoryWrapper>
  );
};